import { render, staticRenderFns } from "./regionSelect.vue?vue&type=template&id=48adc4ef"
import script from "./regionSelect.vue?vue&type=script&lang=js"
export * from "./regionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports